

























import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import InputProps from "@/mixins/InputProps";
import { getElement } from "@/lib/elementHelpers";
import { format, parse, isValid } from "@/lib/time";
import { InputMaskOptions } from "@/modules/inputMask";
import BaseInput from "@/components/BaseInput";

@Component({ name: "BaseInputDate", components: { BaseInput } })
export default class BaseInputDate extends InputProps {
  @Prop({ default: "MM/dd/yyyy" })
  public readonly dateFormat!: string;

  public support = true;

  public get opts(): InputMaskOptions {
    return {
      alias: "datetime",
      inputmode: "numeric",
      inputFormat: this.inputFormat,
      placeholder: this.datePlaceholder,
      min: this.min,
      max: this.max,
    };
  }

  public get min() {
    const date = new Date(0);
    if (!this.support) return format(date, this.dateFormat);
    return format(date, "yyyy-MM-dd");
  }

  public get max() {
    const date = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    if (!this.support) return format(date, this.dateFormat);
    return format(date, "yyyy-MM-dd");
  }

  public get currentValue() {
    if (/\d{4}-\d{2}-\d{2}/.test(this.value)) {
      const date = new Date(this.value);
      return format(date, this.dateFormat.replace("/", ""));
    }
    return this.value;
  }

  public get inputFormat() {
    return this.dateFormat.toLowerCase();
  }

  public get datePlaceholder() {
    return this.inputFormat.toUpperCase();
  }

  public onInput(v: string) {
    const date = parse(v, this.dateFormat, new Date());
    if (isValid(date)) {
      this.$emit("input", format(date, "yyyy-MM-dd"));
    } else this.$emit("input", v);
  }

  public mounted() {
    const el = getElement<HTMLInputElement>(this.$refs.input);
    this.support = el.type === "date";
  }
}
